"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.COMPONENT_IDENTIFIER = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _card = require("../../../../../card");
var _collapse = require("../../../../../collapse");
var _formulaBody = _interopRequireDefault(require("../formulaBody"));
var _ExcessFormula = _interopRequireDefault(require("./ExcessFormula.style"));
var _ExcessFormulaHeader = _interopRequireDefault(require("./ExcessFormulaHeader"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var COMPONENT_IDENTIFIER = exports.COMPONENT_IDENTIFIER = 'excessFormula';
var ExcessFormula = function ExcessFormula(props) {
  var disabled = props.disabled,
    errors = props.errors,
    formulaOperators = props.formulaOperators,
    formulaOtherProps = props.formulaOtherProps,
    getFormulaOperandValues = props.getFormulaOperandValues,
    labels = props.labels,
    rule = props.rule,
    ruleChange = props.ruleChange,
    ruleIndex = props.ruleIndex;
  var canExceed = R.prop('canExceedBudget', rule);
  var excessFormulaExists = canExceed && R.prop(COMPONENT_IDENTIFIER, rule);
  return /*#__PURE__*/_react["default"].createElement(_collapse.Collapse, {
    openItems: excessFormulaExists ? [0] : []
  }, function (_ref) {
    var toggle = _ref.toggle,
      openItems = _ref.openItems;
    var isExpanded = openItems.includes(0);
    return /*#__PURE__*/_react["default"].createElement(_ExcessFormula["default"], {
      isOpen: isExpanded,
      "data-testid": "excess-formula"
    }, /*#__PURE__*/_react["default"].createElement(_card.ControlCard, {
      id: "excess-control-card",
      className: "excess-control-card",
      title: /*#__PURE__*/_react["default"].createElement(_ExcessFormulaHeader["default"], {
        canExceed: canExceed,
        labels: labels,
        ruleChange: ruleChange,
        toggle: toggle,
        isExpanded: isExpanded,
        disabled: disabled,
        COMPONENT_IDENTIFIER: COMPONENT_IDENTIFIER
      }),
      checked: canExceed,
      onChange: function onChange(_, checked) {
        ruleChange('canExceedBudget', checked);
        if (isExpanded) {
          toggle(0);
        }
      },
      disabled: disabled
    }, isExpanded && /*#__PURE__*/_react["default"].createElement(_formulaBody["default"], {
      componentIdentifier: COMPONENT_IDENTIFIER,
      rule: rule,
      labels: labels,
      errors: errors,
      formulaOperators: formulaOperators,
      disabled: disabled,
      ruleChange: ruleChange,
      ruleIndex: ruleIndex,
      getFormulaOperandValues: getFormulaOperandValues,
      formulaOtherProps: formulaOtherProps
    })));
  });
};
ExcessFormula.defaultProps = {
  errors: {},
  disabled: false,
  formulaOtherProps: {},
  formulaOperators: []
};
ExcessFormula.propTypes = {
  disabled: _propTypes["default"].bool,
  rule: _propTypes["default"].shape({}).isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleIndex: _propTypes["default"].number.isRequired,
  errors: _propTypes["default"].shape({}),
  formulaOperators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    name: _propTypes["default"].string
  })),
  formulaOtherProps: _propTypes["default"].shape({}),
  getFormulaOperandValues: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ExcessFormula;